export const AI_ROUTES = {
  RANKING: "/ai/ranking",
  AI_PLATFORM: "/ai",
  AI_CHAT: "/ai/chat",
  AI_MODELS: "/ai/models",
  AI_GENERATE: "/ai/generate",
  AI_NICE_TRAVEL: "/ai/nice-travel",
  AI_ANALYSIS: "/ai/analysis",
  AI_WORKFLOW_POLICY: "/ai/runtime",
} as const;

export type AiRouteKey = keyof typeof AI_ROUTES;
